window.DISABLE_RECHARGE = 'true'; // Respectfully, Recharge, please go away.

(function() {

  class BlendVariantPicker extends HTMLElement {

    _product
    _variants
    _selectedVariant

    connectedCallback() {
      this.addEventListener('change', this._elementChanged.bind(this));

      this._product = JSON.parse(this.productScriptElement?.text ?? '{}');
      this._variants = JSON.parse(this.variantsScriptElement?.text ?? '[]');

      const selectedOption = this.querySelector('input[is="blend-variant-option"]:checked');
      if (selectedOption) {
        this._setSelectedVariant(selectedOption.value);
      }

    }

    _elementChanged(event) {
      if (event.target instanceof BlendVariantOption) {
        this._optionChanged(event);
      }
    }

    _optionChanged(event) {
      // TODO Dispatch variant:changed

      if (event.target.checked != true) {
        return;
      }

      const selectedVariantId = event.target.value;
      this._setSelectedVariant(selectedVariantId);
    }

    _setSelectedVariant(id) {
      const product = this._product;
      const previousVariant = this._selectedVariant;
      const variant = this._getVariant(id);

      const changeEvent = new CustomEvent('variant:change', {
        detail: { product, variant, previousVariant },
        bubbles: true,
        cancelable: false
      });
      
      this._selectedVariant = variant;

      this.formOutlet.dispatchEvent(changeEvent);
    }

    _getVariant(id) {
      return this._variants.find(v => v.id.toString() == id.toString());
    }

    get productScriptElement() {
      return this.querySelector('script[data-blend-variant-picker-target="product"]');
    }
    
    get variantsScriptElement() {
      return this.querySelector('script[data-blend-variant-picker-target="variants"]');
    }

    get formOutlet() {
      return document.querySelector(this.getAttribute('data-blend-variant-picker-form-outlet'));
    }

  }

  class BlendVariantOption extends HTMLInputElement {

    connectedCallback() {
      this.addEventListener('change', this._elementChanged.bind(this));
    }

    _elementChanged(event) {
      if ( this.siblingSellingPlanTarget ) {
        this.siblingSellingPlanTarget.checked = this.checked;
      }
    }

    get siblingSellingPlanTarget() {
      return this.parentElement.querySelector('input[name="selling_plan"]');
    }

  }

  class BlendProductForm extends HTMLFormElement {

    connectedCallback() {
      this.addEventListener('submit', this._elementSubmitted.bind(this));
    }

    _elementSubmitted(event) {
      const cartEvent = new CustomEvent('cart:refresh', { bubbles: true, cancelable: false });
      this.dispatchEvent(cartEvent);
    }

  }

  window.customElements.define('blend-variant-picker', BlendVariantPicker);
  window.customElements.define('blend-variant-option', BlendVariantOption, { extends: 'input' });
  window.customElements.define('blend-product-form', BlendProductForm, { extends: 'form' });

})();